import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AnalyticsEventRow } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const PAGE = 50;

const EventosRecentes: React.FC<Props> = ({ events }) => {
  const [limit, setLimit] = useState(PAGE);
  const visible = events.slice(0, limit);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Eventos recentes</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data/Hora</TableHead>
                <TableHead>Evento</TableHead>
                <TableHead>Página</TableHead>
                <TableHead>Dispositivo</TableHead>
                <TableHead>Usuário</TableHead>
                <TableHead>Metadata</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {visible.map((e) => {
                const meta = e.metadata ? JSON.stringify(e.metadata) : "";
                return (
                  <TableRow key={e.id}>
                    <TableCell className="text-xs whitespace-nowrap">
                      {new Date(e.created_at).toLocaleString("pt-BR")}
                    </TableCell>
                    <TableCell className="text-xs font-mono">{e.event_type}</TableCell>
                    <TableCell className="text-xs">{e.path || "-"}</TableCell>
                    <TableCell className="text-xs">{e.device || "-"}</TableCell>
                    <TableCell className="text-xs">
                      {e.user_id ? (
                        <span className="text-green-600">logado</span>
                      ) : (
                        <span className="text-muted-foreground">anônimo</span>
                      )}
                    </TableCell>
                    <TableCell className="text-xs max-w-[300px] truncate" title={meta}>
                      {meta.length > 80 ? meta.slice(0, 80) + "…" : meta}
                    </TableCell>
                  </TableRow>
                );
              })}
              {visible.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} className="text-center text-sm text-muted-foreground">
                    Sem eventos no período.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        {limit < events.length && (
          <div className="mt-3 flex justify-center">
            <Button variant="outline" size="sm" onClick={() => setLimit((l) => l + PAGE)}>
              Mostrar mais ({events.length - limit} restantes)
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default EventosRecentes;
